module.exports = __webpack_public_path__ + "img/profile_default.4f2182d7.png";